// Puente entre el interceptor de axios y <ClaveSeguraDialog /> (mismo patrón que snackbarService).
let _pedir = null;
let _cola = Promise.resolve();
const _pendientes = {};

export const registerClaveSegura = (fn) => { _pedir = fn; };

// Abre el diálogo de la clave de seguridad para un ámbito (p.ej. "fortinet:25").
// Resuelve true si el usuario desbloquea. Varios 423 del mismo ámbito comparten
// diálogo; los de ámbitos distintos se piden uno detrás de otro.
export const pedirClaveSegura = (opciones = {}) => {
  if (!_pedir) return Promise.resolve(false);
  const ambito = opciones.ambito || "global";
  if (!_pendientes[ambito]) {
    const p = _cola.then(() => _pedir({ ...opciones, ambito }));
    _cola = p.catch(() => {});
    _pendientes[ambito] = p.finally(() => { delete _pendientes[ambito]; });
  }
  return _pendientes[ambito];
};

// true si el error es el 423 de "clave de seguridad requerida" (p.ej. el usuario canceló el diálogo).
export const esClaveSeguraRequerida = (error) =>
  error?.response?.status === 423 && error.response.data?.code === "CLAVE_SEGURA_REQUERIDA";
